import React from 'react'

function FilterLeftSvg() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 10.5C2 10.2239 2.22386 10 2.5 10H5.5C5.77614 10 6 10.2239 6 10.5C6 10.7761 5.77614 11 5.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z" fill="#323232" />
      <path d="M2 7.5C2 7.22386 2.22386 7 2.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z" fill="#323232" />
      <path d="M2 4.5C2 4.22386 2.22386 4 2.5 4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H2.5C2.22386 5 2 4.77614 2 4.5Z" fill="#323232" />
    </svg>

  )
}

export default FilterLeftSvg